import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

const Categories = (props) => {
  const lang = useSelector((state) => state.lang);
  return (
    <section className="flat-spacing-6 pb_0">
      <div className="container">
        <div className="row">
          {props.data.map((category, index) => (
            <div
              key={index}
              className="col-6 col-lg-3 collection-item-v3 hover-img wow fadeInUp mb-3"
              data-wow-delay="0s"
            >
              <Link
                to={`/products/${category.slug}`}
                className="collection-image img-style"
              >
                <img
                  className="lazyload"
                  data-src={category.image}
                  src={category.image}
                  alt="collection-img"
                />
              </Link>
              <div className="collection-content text-center mt-2">
                <Link
                  to={`/products/${category.slug}`}
                  className="link title fw-5"
                >
                  <span>
                    <b>{lang === "ar" ? category.title_ar : category.title}</b>
                  </span>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Categories;
